import { render } from "./B2bFiltersGenralsEmit.vue?vue&type=template&id=670c3954&scoped=true&lang=pug"
import script from "./B2bFiltersGenralsEmit.vue?vue&type=script&lang=js"
export * from "./B2bFiltersGenralsEmit.vue?vue&type=script&lang=js"

import "./B2bFiltersGenralsEmit.vue?vue&type=style&index=0&id=670c3954&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670c3954"]])

export default __exports__